// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3DXWk","tab":"ProcedureTabs_tab__cLpRb"};